export { default } from '../../rewards/history';
export * from '../../rewards/history';
